export default __webpack_public_path__ + "assets/media/unhappy.001ba3e6.png";